import Fn from "jj-browser-fn";
import PageApi from "@/apis/pageApi";
import md5 from "js-md5";
// const SIGN_KEY = "79e9a72c7d4611eebd1100163e381040"; // 测试
const SIGN_KEY = "8e12130c7d4611eebd1100163e381040"; // 正式
const OLDSIGN_KEY = "7PZJImoeAE5Dnjb6pCYu8Ja5Buhb2urL";
import { boxCollect } from "@/req/collect"; // 埋点上报
import httpApi from "@/apis/httpApi";
const ProjFn = {
  ...Fn,
  // 跳转路由
  toRoute: (route: string) => {
    window.App.$router.push({
      path: route,
    });
  },
  backLogin: () => {
    window.App.$router.push({
      path: PageApi.login.path,
    });
  },
  // 添加全局公共方法
  checkHttpResponse: (res: any, errorFn: any, isNotice: boolean) => {
    return new Promise((resolve) => {
      if (res && ProjFn.n(res.code) === 200) {
        resolve(res.data);
      } else {
        // tslint:disable-next-line:no-unused-expression
        errorFn ? errorFn(res) : "";
        if (isNotice) {
          window.App.$Message.error(res.msg);
        }
      }
    });
  },
  showMsgResponse: (res: any, errorFn?: any) => {
    return ProjFn.checkHttpResponse(res, errorFn, true);
  },
  handleResponse: (res: any, errorFn: any) => {
    return ProjFn.checkHttpResponse(res, errorFn, false);
  },
  // 接口验签
  toSign: (obj, signObj?) => {
    // 按照升序排序obj属性
    const sortObj = obj ? obj : {};
    // 生成随机数
    const chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    let resNum = "";
    for (let i = 0; i < 32; i++) {
      const id = Math.ceil(Math.random() * 35);
      resNum += chars[id];
    }
    const newkey = Object.keys(sortObj).sort();
    const newObj: any = {};
    newkey.forEach((item, i) => {
      // 遍历newkey数组
      newObj[newkey[i]] = sortObj[newkey[i]];
      // 向新创建的对象中按照排好的顺序依次增加键值对
    });
    const keyArr = new Array();
    for (const y in newObj) {
      if (true) {
        const x = newObj[y];
        keyArr.push(x);
        if (newObj[y] == undefined || newObj[y] == null) {
          newObj[y] = "";
        }
      }
    }
    newObj.rqtime = Date.parse(String(new Date()));
    newObj.rqrandom = resNum;
    const key = ProjFn.getSignKey(signObj);
    keyArr.push(newObj.rqtime);
    keyArr.push(newObj.rqrandom);
    // keyArr.push(SIGN_KEY);
    keyArr.push(key);
    let sginStr = "";
    keyArr.filter((item) => {
      if (typeof item == "object") {
        return JSON.stringify(item);
      }
    });
    // 将字符串按验签规则拼接
    for (const y in keyArr) {
      if (true) {
        if (typeof keyArr[y] == "object" && keyArr[y] != null) {
          sginStr = sginStr + JSON.stringify(keyArr[y]);
        } else if (keyArr[y] == undefined || keyArr[y] == null) {
          keyArr[y] = "";
          sginStr = sginStr;
        } else {
          sginStr = sginStr + keyArr[y];
        }
      }
    }
    if (signObj) {
      const value = `appv=${signObj.appv}&device=${signObj.device}&deviceId=${
        signObj.deviceId
      }&box-agent=${ProjFn.headerBoxAgent(signObj)}&${sginStr}`;
      newObj.sign = md5(value);
    } else {
      newObj.sign = md5(sginStr);
    }
    // newObj.token = token;
    return newObj;
  },
  getBoxVersion() {
    const appv: any = sessionStorage.getItem("appv")
      ? sessionStorage.getItem("appv")
      : "1.0.0";
    const strVersion: any = appv.replace(/&.+/, "");
    const numVersion = strVersion.replace(/[^0-9]/g, "");
    const mainVersion = numVersion.slice(0, 3);
    return Number(mainVersion);
  },
  getSignKey: (signObj) => {
    const version = ProjFn.getBoxVersion();
    const device = sessionStorage.getItem("device") || ProjFn.mobile();
    if (signObj) {
      if (device == "ios") {
        if (version >= 501) {
          return httpApi.newSignKeyIosV3;
        } else if (version >= 371) {
          return httpApi.newSignKeyIos;
        } else {
          return httpApi.signKey;
        }
      } else {
        if (version >= 501) {
          return httpApi.newSignKeyAdV3;
        } else if (version >= 382) {
          return httpApi.newSignKeyAd;
        } else {
          return httpApi.signKey;
        }
      }
    } else {
      return httpApi.oldSignKey;
    }
  },
  headerBoxAgent(obj: any) {
    const param = Object.keys(obj);
    const data = Object.values(obj);
    let sign = "";
    param.forEach((item, index) => {
      const val = data[index] === undefined ? "" : data[index];
      sign += `${item}:${val};`;
    });
    return sign;
  },
  // 时间转换
  toDates: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
      ];
      return `${Y}-${M}-${D} ${h}`;
    }
  },
  toDate: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
      ];

      return `${Y}-${M}-${D} ${h}:${m}`;
    }
  },
  // 截取url中的数据
  getUrlData: () => {
    const temp = window.location.href;
    const tempStr = decodeURIComponent(decodeURIComponent(temp));
    let tempArr = tempStr.split("?")[1] ? tempStr.split("?")[1].split("&") : [];
    const str = document.cookie.replace(/\s/g, "");
    tempArr = [...tempArr, ...str.split(";")];
    tempArr.forEach((element) => {
      sessionStorage.setItem(element.split("=")[0], element.split("=")[1]);
    });
    const tempObj = {};
    tempArr.forEach((item, i) => {
      tempObj[item.split("=")[0]] = item.split("=")[1];
    });
    if (!sessionStorage.getItem("device")) {
      sessionStorage.setItem("device", ProjFn.mobile());
    }
    if (!sessionStorage.getItem("appv")) {
      if (ProjFn.mobile() == "ios") {
        sessionStorage.setItem("appv", "3.7.1");
      } else {
        sessionStorage.setItem("appv", "3.8.2");
      }
    }
  },
  // 数据收集   例子 => this.$fn.boxCollectChange("1", '{ "uid": "123" }');
  boxCollectChange: async (I, D) => {
    const obj = {
      i: I, // 事件id
      d: JSON.stringify(D), // 收集数据
      t: String(Date.parse(String(new Date()))), // 时间戳
    };
    const res = await boxCollect(obj);
  },
  mobile: () => {
    const ua = navigator.userAgent;
    // andrord
    const isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1;
    // IOS
    const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      return "android";
    }
    if (isIOS) {
      return "ios";
    }
    return "pc";
  },
};

export default ProjFn;
